// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceValueVector
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DataSourceValue } from "abweb/dto/ds/DataSourceValue";
import { DataFieldTypeEnum } from "abweb/dto/generated/ds/DataFieldTypeEnum";
import { DataSourceSaveAction } from "abweb/dto/generated/ds/DataSourceSaveAction";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class DataSourceValueVectorBase extends DataSourceValue {
  /** Do NOT invoke directly, instead use strongly typed createDataSourceValueVectorBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.DataSourceValueVector";
  }
  initFromJson(json, deserializeContext) {
    this.initDataSourceValueVector(json.attributeValues != null ? json.attributeValues : null, json.clientTag != null ? json.clientTag : null, json.dataSourceSaveAction != null ? DataSourceSaveAction.fromJson(json.dataSourceSaveAction) : null, json.editableOverwrite != null ? json.editableOverwrite : null, json.id != null ? json.id : null, json.state != null ? DataSourceState.fromJson(json.state) : null, json.itemFieldTypeOverwrite != null ? DataFieldTypeEnum.fromJson(json.itemFieldTypeOverwrite) : null, json.items != null ? TSOGUtils.decodeObjectArray(json.items, null, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "items")) : null);
  }
  initDataSourceValueVector(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, itemFieldTypeOverwrite, items) {
    this.initDataSourceValue(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state);
    this._itemFieldTypeOverwrite = itemFieldTypeOverwrite;
    this._items = items;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._itemFieldTypeOverwrite != null) {
      retVal["itemFieldTypeOverwrite"] = this._itemFieldTypeOverwrite;
    }
    if (this._items != null) {
      retVal["items"] = TSOGUtils.toTSOGArray(this._items, serializeContext);
    }
    return retVal;
  }
  get itemFieldTypeOverwrite() {
    return this._itemFieldTypeOverwrite;
  }
  set itemFieldTypeOverwrite(value) {
    this._itemFieldTypeOverwrite = value;
  }
  get items() {
    return this._items;
  }
  set items(value) {
    this._items = value;
  }
}
//# sourceMappingURL=DataSourceValueVectorBase.js.map
